import React from "react"
import { Layout as AntDLayout } from "antd"

const { Footer } = AntDLayout

const footer = () => <Footer>Footer</Footer>

export default footer
